/**
 * Canonical request lifecycle labels (aligned with bookings.requestStatuses.* in locales).
 */
export function normalizeRequestStatus(status) {
  return String(status || "").trim().toUpperCase();
}

export function getRequestStatusLabel(t, status) {
  const s = normalizeRequestStatus(status);
  if (s === "NEW") return t("bookings.requestStatuses.new");
  if (s === "CHAT_ACTIVE") return t("bookings.requestStatuses.chatActive");
  if (s === "TRIAL_DONE") return t("bookings.requestStatuses.trialDone");
  if (s === "BECAME_CLIENT") return t("bookings.requestStatuses.becameClient");
  if (s === "CLOSED") return t("bookings.requestStatuses.closed");
  if (s === "CANCELLED_BY_STUDENT") return t("bookings.requestStatuses.cancelledByStudent");
  return t("bookings.requestStatuses.active");
}

/** For list rows that need tone + text (e.g. Bookings). */
export function getRequestStatusMeta(t, status) {
  const s = normalizeRequestStatus(status);
  if (s === "BECAME_CLIENT") return { text: t("bookings.requestStatuses.becameClient"), tone: "success" };
  if (s === "CLOSED") return { text: t("bookings.requestStatuses.closed"), tone: "subtle" };
  if (s === "NEW") return { text: t("bookings.requestStatuses.new"), tone: "subtle" };
  if (s === "CHAT_ACTIVE") return { text: t("bookings.requestStatuses.chatActive"), tone: "success" };
  if (s === "TRIAL_DONE") return { text: t("bookings.requestStatuses.trialDone"), tone: "success" };
  if (s === "CANCELLED_BY_STUDENT") return { text: t("bookings.requestStatuses.cancelledByStudent"), tone: "danger" };
  return { text: t("bookings.requestStatuses.active"), tone: "subtle" };
}
